import { ref, readonly, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { AdvancedOptions } from '@/types/components';

export const useCreateOrUpdateFairConView = () => {
  const { t } = useI18n();
  const isActiveAdvancedSettings = ref(false);

  // 고정된 기본값 (변경되지 않음)
  const advancedOptionsDefault = readonly({
    TSS: 0, // 화자 구분 조절
    VAD: 0, // 음성 구분 조절
    SIL: 0, // 문장 구분 조절
  });

  const advancedOptions = ref<AdvancedOptions>({ ...advancedOptionsDefault });

  const gaugeOptions = computed(() => [
    {
      key: 'TSS',
      title: `${t('speaker_separation_control')} (${advancedOptions.value.TSS / 100})`,
      value: advancedOptions.value.TSS / 100,
      min: -20,
      max: 20,
      minLabel: 'Min (-0.2)',
      maxLabel: 'Max (+0.2)',
    },
    {
      key: 'VAD',
      title: `${t('voice_separation_control')} (${advancedOptions.value.VAD / 20})`,
      value: advancedOptions.value.VAD / 20,
      min: -10,
      max: 10,
      minLabel: 'Min (-0.5)',
      maxLabel: 'Max (+0.5)',
    },
    {
      key: 'SIL',
      title: `${t('sentence_separation_control')} (${advancedOptions.value.SIL / 20})`,
      value: advancedOptions.value.SIL / 20,
      min: -12,
      max: 12,
      minLabel: 'Min (-0.6)',
      maxLabel: 'Max (+0.6)',
    },
  ]);

  return {
    isActiveAdvancedSettings,
    advancedOptions,
    advancedOptionsDefault,
    gaugeOptions,
  };
};
